"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageLogsSettings = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _DmsLogsSettings = require("../../components/DmsLogs/DmsLogsSettings");
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsPageLogsSettings Component
 * 
 * @description This component renders the Log Settings page. It displays a breadcrumb navigation and a settings box for log configurations.
 * 
 * @component
 * @example
 * return (
 *   <DmsPageLogsSettings />
 * )
 * 
 * @returns {JSX.Element} The Log Settings page.
 */
const DmsPageLogsSettings = () => {
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "Log Settings"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("LogSettings").d("Log Settings"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsLogsSettings.DmsLogsSettings, null))));
};
exports.DmsPageLogsSettings = DmsPageLogsSettings;